import * as React from 'react';
import { Box } from '@mui/material';
import SignIn from 'pages/sign-in/sign-in';

const AdminSignIn: React.FC = () => {
    return (
        <Box
            display={'flex'}
            height={'100%'}
            justifyContent={'center'}
            alignItems={'center'}
        >
            <SignIn />
        </Box>
    );
};
export default AdminSignIn;
